import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';

/** 終了処理 
 * @param {instance} self 呼び出し元インスタンス
 */
export async function exit(self) {
  try {
    self.isLoading = true;

    // バックエンドAPI POST,GET
    const token = session.getToken();
    await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'terminate'
      },
      // エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );
  } finally {
    self.isLoading = false;
  }
}
